import { currentTab } from '../state'

/**
 * Check if there's a pending OAuth integration
 * @param {Object} route - Vue Router route object
 */
export const checkPendingIntegration = (route) => {
  const { code, integration, tab } = route.query
  
  if (code && integration && tab) {
    currentTab.value = tab
    console.log(`Pending integration detected: ${integration}`)
    // Additional logic can be added here if needed
  }
}
